<template>
  <div class="progress-range" :class="{ status: paymtzNth }">
    <label for="period" v-if="label" @click="onClick">{{ rangeData }}</label>
    <div class="value-ing" v-if="paymtzNth" :style="{ width: percent + '%' }">
      <span class="ing">
        {{ dataValue }}
        <em>{{/*회차*/$t("MCOM-0000091")}}</em>
      </span>
    </div>
    <div class="progress">
      <div class="range-item">
        <input
          type="range"
          class="range-field"
          name="period"
          :min="rMin"
          :max="rMax"
          :step="rStep"
          value="dataValue"
          v-model="dataValue"
        />
      </div>
      <div class="range-fill" :style="{ background: fill }"></div>
      <div v-if="date" class="division">
        <span v-for="(item, i) in getRangeList('division')" :key="i" class="dot"></span>
      </div>
      <div v-if="num" class="division">
        <span class="dot"></span>
        <span class="dot"></span>
      </div>
      <div v-if="date" class="option">
        <span v-for="(item, i) in getRangeList('option')" :key="i">{{ item }}</span>
      </div>
      <div v-if="num" class="option">
        <div class="start">
          <span>{{ rMin }}</span>
        </div>
        <div class="end">
          <span v-html="$num(rMax, null, true)"></span>
        </div>
      </div>
    </div>
  </div>
</template>
<style type="scss" scoped></style>
<script>
export default {
  components: {},
  props: ["label", "value", "min", "max", "step", "date", "num", "data", "dataList", "paymtzNth"],
  data() {
    return {
      dotMax: 0,
    };
  },
  computed: {
    fill() {
      const fill = [];
      fill.push(((this.dataValue - this.rMin) / (this.rMax - this.rMin)) * 100);
      return `linear-gradient(to right, #ffd719 ${fill[0]}%, #f0f0f0 ${fill[0]}%)`;
    },
    percent() {
      const fill = [];
      fill.push(((this.rangeData - 1) / this.rMax) * 100);
      return fill[0];
    },
    rMin() {
      if (this.dataList != null && this.dataList.length > 0) {
        return 1;
      } else {
        return this.min;
      }
    },
    rMax() {
      if (this.dataList != null && this.dataList.length > 0) {
        return this.dataList.length;
      } else {
        return this.max;
      }
    },
    rStep() {
      if (this.dataList != null && this.dataList.length > 0) {
        return 1;
      } else {
        return this.step;
      }
    },
    dataValue: {
      get() {
        return this.value;
      },
      set(value) {
        let tmpData;

        if (this.dataList == null) {
          tmpData = value;
        } else {
          if (this.dataList.length > 0) {
            if (value <= this.dataList.length) {
              tmpData = this.dataList[value - 1];
            } else {
              tmpData = "";
            }
          } else {
            tmpData = value;
          }
        }

        this.$emit("update:data", tmpData);
        this.$emit("update:value", value);
      },
    },
    rangeData: {
      get() {
        return this.data;
      },
      set(value) {
        this.$emit("update:data", value);
      },
    },
  },
  created() {
    if (this.data != null && this.dataList != null && this.dataList.length > 0) {
      let fndIndx = this.dataList.findIndex(item => {
        return item == this.data;
      });

      if (fndIndx < 0) fndIndx = 0;

      this.dataValue = fndIndx + 1;
      this.rangeData = this.dataList[fndIndx];
    } else {
      if (this.dataValue == null || this.dataValue == "" || this.dataValue < 1) {
        this.dataValue = this.rMin;
        this.rangeData = this.rMin;
      }
    }
  },
  methods: {
    setValue(value) {
      let pos = 1;

      if (value != null) {
        if (this.dataList == null) {
          pos = value;
        } else {
          if (this.dataList.length > 0) {
            let fndIdx = this.dataList.findIndex(item => {
              return item == value;
            });

            if (fndIdx > -1) {
              pos = fndIdx + 1;
            }
          }
        }
      }

      this.dataValue = pos;
    },
    setDataList(list) {
      let data, value;

      if (list != null && list.length > 0) {
        value = 1;
        data = list[0];
      }

      this.$emit("update:dataList", list);
      this.$emit("update:value", value);
      this.$emit("update:data", data);
    },
    getRangeList(knd) {
      let tmp = [];
      let dot = 0;
      if (this.paymtzNth) {
        this.dotMax = this.dataList.length;
      } else {
        this.dotMax = 10;
      }

      if (this.dataList != null && this.dataList.length > 0) {
        dot = this.dataList.length;

        if (dot > 0) {
          if (knd == "division" || dot <= this.dotMax) {
            tmp = new Array(dot).fill("").map((n, i) => {
              return this.dataList[i];
            });
          } else {
            for (let i = this.dotMax - 1; i > 0; i--) {
              if ((dot - 1) % i == 0) {
                dot = i;
                break;
              }
            }

            if (dot < 2) dot = 2;
            else dot++;

            tmp = new Array(dot).fill("").map((n, i) => {
              if (i == 0) {
                return this.dataList[i];
              } else if (i == dot - 1) {
                return this.dataList[this.dataList.length - 1];
              } else {
                let dotStep = Math.trunc((this.dataList.length - 1) / (dot - 1));
                return this.dataList[i * dotStep];
              }
            });
          }
        }
      } else {
        dot = Math.ceil((this.rMax - this.rMin) / this.rStep) + 1;

        if (dot > 0) {
          tmp = new Array(dot).fill(Number(this.rMin)).map((n, i) => {
            if (i == 0) return n;
            else return n + i * this.rStep;
          });
        }
      }

      return tmp;
    },
    onClick() {
      this.$emit("labelClick");
    },
  },
};
</script>
